import React, { useEffect, useState } from "react";
import {
  Alert,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";

import { showTopbarInsideAction } from "../../../store/actions";

import { useDispatch, useSelector } from "react-redux";
import { editLogin, resetProfileFlag  } from "../../../store/auth/profile/actions";

import HeaderDefaultToPage from "../../../components/Common/headerDefaultToPage";
import BizinBackend from "../../../helpers/bizin_helper";
import NotificationModal from "../../../components/Common/NotificationModal";
import useGetCsrfToken from "../../../Hooks/useGetCsrfToken";

const BI_WS0005 = () => {
  document.title = "Defender | Minha Segurança";

  const dispatch = useDispatch();
  const [messageAlert, setMessageAlert] = useState(null); // erros/avisos no formulário
  const [messageAlertModal, setMessageAlertModal] = useState(null); // erros/avisos dentro dos modais
  const csrfToken = useGetCsrfToken();
  
  const { userProfile } = useSelector((state) => ({
    userProfile: state.login.user,
  }));
  
  const profileState = useSelector((state) => state.profile);

  const [showCodeModal, setShowCodeModal] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [isSecondPhase, setIsSecondPhase] = useState(false);

  const [verificationCode, setVerificationCode] = useState([
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  const [newEmail, setNewEmail] = useState("");
  
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const [notif, setNotif] = useState({
    isOpen: false,
    type: "success",
    message: "",
  });

  const [inputs, setInputs] = useState({
    Email_Atual: userProfile?.resultset_2?.[0]?.Email || "",
    whatsapp: false,
    sms: false,
    email: true,
  });

  const handleCloseNotif = () => {
    setNotif((s) => ({ ...s, isOpen: false }));
  };

  const resetCodeModal = () => {
    setShowCodeModal(false);
    setVerificationCode(["", "", "", "", "", ""]);
    setMessageAlert(null);
    setMessageAlertModal(null);
  };

  const resetEmailModal = () => {
    setShowEmailModal(false);   
    setMessageAlert(null);
    setMessageAlertModal(null);    
  };

  const closeCodeModal = () => {
    setShowCodeModal(false);
    setVerificationCode(["", "", "", "", "", ""]);
    setMessageAlertModal(null);
  };

  const toggleCodeModal = () => {
    closeCodeModal();
  };

  const generateToken = async () => {      

    setMessageAlert(null);
    setMessageAlertModal(null);
    setNewEmail("")

    try {
      const prm = { email: inputs.Email_Atual };
            
      const resp = await BizinBackend.executeProcedure(
        prm,
        "FRONT_Workspace_Gerar_Token_Usuario",
        csrfToken,
        userProfile?.access_token
      );      

      if (Array.isArray(resp) && resp[0]?.statusCode === 200) {        
        
        setMessageAlertModal({ message: resp[0].message, color: "success" });
        setShowCodeModal(true);
      } else {
        
        setMessageAlertModal({
          message: resp[0]?.message || "Falha ao gerar token",
          color: "danger",
        });
      }
    } catch (err) {
      console.error('💥 Erro na função generateToken:', err);
      setMessageAlertModal({
        message: err.message || "Erro ao gerar código de verificação",
        color: "danger",
      });
    }
  };
  
  // Função que valida o token digitado (fase 1 e fase 2)
  const validateToken = async () => {
    const token = verificationCode.join("");
    setMessageAlert(null);
    setMessageAlertModal(null);

    try {
      const prm = {
        Email: inputs.Email_Atual,
        Token: token,
      };
      
      const resp = await BizinBackend.executeProcedure(
        prm,
        "FRONT_Workspace_Validar_Token_Usuario",
        csrfToken,
        userProfile?.access_token
      );

      if (Array.isArray(resp) && resp[0]?.statusCode === 200) {
      
          resetCodeModal();
          setShowEmailModal(true);
      } else {
        setMessageAlertModal({
          message: resp[0]?.message || "Token inválido.",
          color: "danger",
        });
      }
    } catch (err) {
      setMessageAlertModal({
        message: err.message || "Erro ao validar token.",
        color: "danger",
      });
    }
  };

  const confirmEmailChange = () => {
    
    const token = verificationCode.join("");
    setMessageAlertModal(null);

    dispatch(editLogin({     
      Novo_Email:  newEmail.trim(),
      Token:       token,
      _csrf:       csrfToken,
      _access_token_msman: userProfile?.access_token
    }));
  };

  const generateTokenEmailExchange = async () => {
    setMessageAlertModal(null);

    try {
      const prm = {
        Email_Atual: inputs.Email_Atual,
        Novo_Email: newEmail.trim(),
      };
      const resp = await BizinBackend.executeProcedure(
        prm,
        "FRONT_Workspace_Gerar_Token_Alteracao_Email",
        csrfToken,
        userProfile?.access_token
      );

      if (Array.isArray(resp) && resp[0]?.statusCode === 200) {
     
        setVerificationCode(["", "", "", "", "", ""]);
        resetEmailModal();
        setIsSecondPhase(true);
        setShowCodeModal(true);
      } else {
        setMessageAlertModal({
          message:
            resp[0]?.message || "Falha ao gerar token para alteração de e-mail.",
          color: "danger",
        });
      }
    } catch (err) {
      setMessageAlertModal({
        message:
          err.message || "Erro ao gerar token para alteração de e-mail.",
        color: "danger",
      });
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();    
    resetCodeModal();
    resetEmailModal();
    setMessageAlert(null);
    setIsSecondPhase(false);
    

    if (!inputs.Email_Atual.length) {
      setMessageAlert({ message: "Insira seu e-mail atual.", color: "warning" });
      return;
    }
    if (!inputs.whatsapp && !inputs.email && !inputs.sms) {
      setMessageAlert({
        message: "Selecione um canal de comunicação.",
        color: "warning",
      });
      return;
    }
      
    generateToken();
  };

  useEffect(() => {
    if (profileState.success) {
      const novo = newEmail.trim();
      setNotif({
        isOpen:  true,
        type:    "success",
        message: `Seu novo e-mail ${novo} foi confirmado.`,
      });
      setInputs((s) => ({ ...s, Email_Atual: novo }));
      resetCodeModal();
      setIsSecondPhase(false);
      setNewEmail("");
      dispatch(resetProfileFlag());
    }
  }, [profileState.success]);

  useEffect(() => {
    if (profileState.error) {
      setMessageAlertModal({
        message: profileState.error,
        color:   "danger",
      });
      dispatch(resetProfileFlag());
    }
  }, [profileState.error]);

  useEffect(() => {
    dispatch(showTopbarInsideAction({}));
  }, [dispatch]);

  return (
    <React.Fragment>

      <Modal
        isOpen={showCodeModal}
        toggle={toggleCodeModal}
        centered
        size="lg"
      >
        <ModalHeader toggle={resetCodeModal}>
          <h5 className="font-size-16 font-w-600 text-color-azul1">
            Confirmação do código de verificação
          </h5>
        </ModalHeader>
        <ModalBody className="text-center">
          <p className="mb-2">
            Por favor, digite o código que enviamos para:
          </p>
          <p className="mb-5">
            <strong>
               {isSecondPhase ? newEmail.trim() : inputs.Email_Atual}
            </strong>
          </p>

          {messageAlertModal && (
            <div className="mt-3">
              <Alert color={messageAlertModal.color}>
                {messageAlertModal.message}
              </Alert>
            </div>
          )}

          <div className="d-flex justify-content-center gap-2">
            {verificationCode.map((digit, idx) => (
              <input
                key={idx}
                id={`code-${idx}`}
                className="digit-input"
                type="text"
                maxLength={1}
                value={digit}
                onChange={(e) => {
                  const v = e.target.value.replace(/\D/, "");
                  setVerificationCode((code) => {
                    const copy = [...code];
                    copy[idx] = v;
                    return copy;
                  });
                  if (v && idx < 5) {
                    document.getElementById(`code-${idx + 1}`)?.focus();
                  }
                }}
                onKeyDown={(e) => {
                  if (e.key === "Backspace") {
                    e.preventDefault();
                    setVerificationCode((code) => {
                      const copy = [...code];
                      copy[idx] = "";
                      return copy;
                    });
                    if (!digit && idx > 0) {
                      document.getElementById(`code-${idx - 1}`)?.focus();
                    }
                  }
                }}
                onPaste={(e) => {
                  e.preventDefault();
                  const paste = e.clipboardData
                    .getData("Text")
                    .replace(/\D/g, "")
                    .slice(0, 6 - idx);
                  if (!paste) return;
                  const digits = paste.split("");
                  setVerificationCode((code) => {
                    const copy = [...code];
                    for (let i = 0; i < digits.length; i++) {
                      if (idx + i < 6) {
                        copy[idx + i] = digits[i];
                      }
                    }
                    return copy;
                  });
                  const nextIndex = Math.min(idx + digits.length, 5);
                  document.getElementById(`code-${nextIndex}`)?.focus();
                }}
                onFocus={(e) => e.target.select()}
              />
            ))}
          </div>

          <p className="mt-5">
            Não encontrou?{" "}
            <a href="#"
              onClick={(e) => {
                e.preventDefault();
                generateToken();
              }}
            >
              Reenviar código
            </a>
          </p>
        </ModalBody>
        <ModalFooter  className="border-0">
          <Button
            className="mx-2 btn btn-primary-dark border-0 p-3"
            type="button"
            color="primary-dark"
            onClick={isSecondPhase ? confirmEmailChange : validateToken}
          >
            Confirmar código 
          </Button>
        </ModalFooter>
      </Modal>

      {/* 2º Modal: Alteração de e-mail */}
      <Modal
        isOpen={showEmailModal}
        toggle={resetEmailModal}
        centered
        size="lg"
      >
        <ModalHeader toggle={resetEmailModal}>
          <h5 className="font-size-16 font-w-600 text-color-azul1">
            Alteração de e-mail
          </h5>
        </ModalHeader>
        <ModalBody>
          <p className="text-center font-weight-medium m-0">
            <strong>Código confirmado!</strong>
          </p>
          <p className="text-center mb-4">
            Digite o novo e-mail no campo abaixo:
          </p>
          <div className="col-8 mx-auto mb-4">
            <div className="mb-3 form-default-primary">
              <label className="font-w-400">E-mail Atual</label>
              <div className="form-control d-flex align-items-center gap-3 disabled">
                <i className="fas fa-user-tie icon-input"></i>
                <input
                  type="email"       
                  className="flex-grow-1"        
                  value={inputs.Email_Atual}
                  disabled               
                />
              </div>
            </div>

            <div className="form-group mb-1 form-default-primary">
              <label className="font-w-400">Novo E-mail</label>
              <div className="form-control d-flex align-items-center gap-2">
                <i className="fas fa-user-tie icon-input"></i>
                <input
                  type="email"
                  className="flex-grow-1"
                  placeholder="Insira seu novo e-mail"
                  value={newEmail}
                  onChange={(e) => setNewEmail(e.target.value)}
                />
              </div>
            </div>

            <p className="text-center m-4">
              Para confirmar a alteração, iremos enviar um código para o e-mail
              informado no campo acima.
            </p>
          </div>

          {messageAlertModal && (
            <div className="mt-2 text-center">
              <Alert color={messageAlertModal.color}>
                {messageAlertModal.message}
              </Alert>
            </div>
          )}
        </ModalBody>
        <ModalFooter className="border-0">
            <Button
              className="mx-2 btn btn-primary-dark border-0 p-3" 
              type="button"
              color="primary-dark"
              pattern="[^\s@]+@[^\s@]+\.[^\s@]+"
              title="Formato de e-mail inválido"
              onClick={() => {

              const email = newEmail.trim();
              if (!email) {
                  setMessageAlertModal({
                    message: "Informe o novo e-mail antes de enviar.",
                    color: "warning",
                  });
                  return;
                }
              if (!isValidEmail(email)) {
                setMessageAlertModal({
                  message: "Por favor, insira um e-mail válido.",
                  color: "warning",
                });
                return;
              }
                generateTokenEmailExchange();
              }}
            >
              Enviar código
            </Button>
        </ModalFooter>
      </Modal>

      <NotificationModal
        isOpen={notif.isOpen}
        type={notif.type}
        message={notif.message}
        onClose={() => setNotif(s => ({ ...s, isOpen: false }))}
      />

      {/* Formulário “Alterar Login” */}
      <div className="page-content page-config">
        <Container fluid={true} className="dataTable-custom-primary">
          <HeaderDefaultToPage
            goBackPage={"/BI_WS0002"}
            title={"Minha Segurança"}
          />
          <div className="row content-page my-4">
            <div className="col-lg-4 col-md-5 col-12">
              <div className="bg-white card-content w-100">
                <div className="card-body">
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className="m-0 font-size-20 font-w-600 text-primary-dark">
                      Alterar Login
                    </h5>
                  </div>
                  <form
                    className="row mt-3 form-update-email form-default-primary"
                    onSubmit={handleSubmit}
                  >
                    {messageAlert && (
                      <div className="form-grop">
                        <Alert color={messageAlert.color}>
                          {messageAlert.message}
                        </Alert>
                      </div>
                    )}
                    <div className="col-12 mb-3">
                      <small className="font-size-14">
                        Ao alterar seu e-mail, o login de acesso à plataforma
                        também será atualizado
                      </small>
                    </div>
                    <div className="col-12 form-group mb-4">
                      <label className="font-w-400">E-mail Atual</label>
                      <div className="form-control d-flex align-items-center gap-3">
                        <i className="fas fa-user-tie icon-input"></i>
                        <input
                          type="email"
                          placeholder="exemplo@gmail.com"
                          value={inputs.Email_Atual}
                          disabled                         
                        />
                      </div>
                    </div>
                    <div className="col-12 form-group mb-3">
                      <label className="font-w-600">
                        Canal de comunicação para verificação
                      </label>
                      <ul className="ul-list-custom">
                        <li className="border-bottom align-content-center d-none">
                          <div className="d-flex align-items-center justify-content-between w-100">
                            <div className="d-flex align-items-center gap-2">
                              <i className="fab fa-whatsapp"></i>
                              <span>Whatsapp</span>
                            </div>
                            <input
                              type="radio"
                              value="whatsapp"
                              name="whatsapp"
                              className="input-radio-custom"
                              disabled
                              onClick={() =>
                                setInputs((state) => ({
                                  ...state,
                                  whatsapp: !state.whatsapp,
                                }))
                              }
                              checked={inputs.whatsapp}
                            />
                          </div>
                        </li>
                        <li className="border-bottom align-content-center d-none">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                              <i className="far fa-comment"></i>
                              <span>SMS</span>
                            </div>
                            <input
                              type="radio"
                              value="sms"
                              name="sms"
                              className="input-radio-custom"
                              disabled
                              onClick={() =>
                                setInputs((state) => ({
                                  ...state,
                                  sms: !state.sms,
                                }))
                              }
                              checked={inputs.sms}
                            />
                          </div>
                        </li>
                        <li className="align-content-center">
                          <div className="d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center gap-2">
                              <i className="far fa-envelope"></i>
                              <span>E-mail</span>
                            </div>
                            <input
                              type="radio"
                              value={"e-mail"}
                              name="e-mail"
                              className="input-radio-custom"
                              onClick={() =>
                                setInputs((state) => ({
                                  ...state,
                                  email: !state.email,
                                }))
                              }
                              checked={inputs.email}
                            />
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div className="col-12 align-items-center d-flex">
                      <button 
                      className="btn-link-page"                       
                      type="submit"
                      >
                        Enviar código de verificação
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default BI_WS0005;